import * as React from "react";
import Utils from "../../helper/utils";
import DashboardConsumoDetalhe from "./detalhe";
import DashboardConsumoTopo from "./topo";

import { useTranslation } from "react-i18next";

export const DashboardConsumoPage = () => {
  const { t } = useTranslation();

  Utils.setDocumentTitle(t("pages.dashboardContractualComsumption.text.contractualComsumption"), "- Dashboard");

  return (
    <React.Fragment>
      <DashboardConsumoTopo />
      <DashboardConsumoDetalhe />
    </React.Fragment>
  );
};